import { BrowserRouter as Router, Switch } from "react-router-dom";
import HomeTwo from "./pages/homes/HomeTwo";
import HomeOne from "./pages/homes/HomeOne";
import HomeThree from "./pages/homes/HomeThree";
import Shop from "./pages/store/Shop";
import Contact from "./pages/contact/Contact";
import Community from "./pages/community/Community";
import Overview from "./pages/overview/Overview";
import AboutUs from "./pages/aboutpage/aboutuspage/AboutUs";
import Upcoming from "./pages/aboutpage/upcoming/Upcoming";
import GameSingle from "./pages/aboutpage/singlegame/GameSingle";
import Blogs from "./pages/blogs/Blogs";
import BlogDetails from "./pages/blogdetails/BlogDetails";
import ScrollToTopRoute from "./components/scrolltotop/ScrollToTopRoute";
import HomeFour from "./pages/homes/HomeFour";
import HomeFive from "./pages/homes/HomeFive";
import HomeSix from "./pages/homes/HomeSix";
import HomeSeven from "./pages/homes/HomeSeven";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import WebGames from "./pages/aboutpage/web-games/web";
import BusinessModel from "./pages/aboutuspage/AboutUs";
import TermsAndCondition from "./components/legal/terms-conditions";
import PrivacyPolicy from "./components/legal/privacy-policy";
import BusinessModelMudgames from "./pages/business-mudgames/AboutUs";
import BusinessModelGamesGuru from "./pages/business-games-guru/AboutUs";
// import Loader from "react-js-loader";
const queryClient = new QueryClient();

function App() {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <Router>
          <Switch>
            <ScrollToTopRoute exact={true} path="/">
              <HomeTwo />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/index-2">
              <HomeOne />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/index-3">
              <HomeThree />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/blogs">
              <Shop />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/contact">
              <Contact />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/business-model-liveplay">
              <BusinessModel />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/business-mudgames">
              <BusinessModelMudgames />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/business-gamesguru">
              <BusinessModelGamesGuru/>
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/overview">
              <Overview />
            </ScrollToTopRoute>

            <ScrollToTopRoute exact={true} path="/technology">
              <AboutUs />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/downloadable-games">
              <Upcoming />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/web-games">
              <WebGames />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/details/:id">
              <GameSingle />
            </ScrollToTopRoute>

            <ScrollToTopRoute exact={true} path="/blogs/:id">
              <Blogs />
            </ScrollToTopRoute>

            <ScrollToTopRoute exact={true} path="/blog-details">
              <BlogDetails />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/index-4">
              <HomeFour />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/index-5">
              <HomeFive />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/index-6">
              <HomeSix />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/index-7">
              <HomeSeven />
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/terms-conditions" >
              <TermsAndCondition/>
            </ScrollToTopRoute>
            <ScrollToTopRoute exact={true} path="/privacy-policy" >
              <PrivacyPolicy/>
            </ScrollToTopRoute>
          </Switch>
        </Router>
      </QueryClientProvider>
    </div>
  );
}

export default App;
